import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { inviteEvent } from "../../api/client";
import Confetti from "../../assets/svg/Confetti";
import LocationSVG from "../../assets/svg/LocationSVG";
import NotesSVG from "../../assets/svg/NotesSVG";
import GoingSVG from "../../assets/svg/GoingSVG";
import MaybeSVG from "../../assets/svg/MaybeSVG";
import CantGoSVG from "../../assets/svg/CantGoSVG";
import dayjs from "dayjs";
import RSVPModal from "./RSVPModal";
import { useSelector } from "react-redux";
import Loader from "./Loader";
import DresscodeSVG from "../../assets/svg/DresscodeSVG";
import CrownSVG from "../../assets/svg/CrownSVG";
import PopperSVG from "../../assets/svg/PopperSVG";
import CalendarSVGEvent from "../../assets/svg/CalendarSVGEvent";

export const EVite = () => {
  const { eventCode } = useParams();
  const [event, setEvent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [type, setType] = useState("1");

  const navigate = useNavigate();

  // Load event details on mount
  // http://localhost:3000/invite/e577f97878/bd3f7c4ea5a0
  useEffect(() => {
    const fetchEvent = async () => {
      try {
        const _requestData = {
          flag: "init",
          event_code: eventCode,
        };
        const response = await inviteEvent(_requestData);
        if (response.error === 0) {
          setLoading(false);
          setEvent(response.data.event_info);
          if (response.data.event_info?.length === 0) {
            navigate("/category");
          }
        } else {
          navigate("/category");
        }
      } catch (error) {
        navigate("/category");
      }
    };

    if (eventCode) {
      fetchEvent();
    }
  }, [eventCode]);

  if (loading)
    return (
      <div className="py-12">
        <Loader borderColor="border-primary-500" />
      </div>
    );
  if (event?.length === 0) return <p>No event found.</p>;

  console.log(event.event_desc, "event.event_descevent.event_desc");
  return (
    <div className="max-w-md md:max-w-3xl lg:max-w-5xl mx-auto bg-gradient-to-tr from-[#604EA0] to-[#E5637F] min-h-screen text-white relative pb-36">
      <div className="relative">
        <img
          src={event?.cover_img}
          alt="event cover"
          className="w-full h-52 sm:h-64 md:h-80 lg:h-96 object-cover"
        />

        {/* Text block */}
        <div className="absolute text-center bottom-0 left-0 w-full">
          <div className="bg-black/60 text-white p-3 sm:p-4">
            <p className="text-md sm:text-sm md:text-sm">You're invited to</p>
            <h1 className="text-xl sm:text-2xl md:text-3xl font-semibold">
              {event?.event_title}
            </h1>
          </div>
        </div>
      </div>

      <div className="relative overflow-hidden rounded-t-2xl">
        {/* Confetti background */}
        <div className="absolute inset-x-0 top-0 h-40 z-0 pointer-events-none">
          <Confetti />
        </div>

        {/* Invitation card */}
        <div className="pt-4">
          <div className="relative z-10 mb-4 mx-4 rounded-2xl bg-[rgba(38,30,65,0.54)] backdrop-blur-sm">
            <div className="px-5 pt-6">
              <p className=" text-base sm:text-lg text-center leading-relaxed text-white/90">
                <span className=" font-semibold">{event.full_name}</span>{" "}
                invites you to{" "}
                <span className="font-semibold">{event.event_title}</span>, a
                special{" "}
                <span className="font-semibold">{event.event_type}</span> that
                will be held at{" "}
                <span className="font-semibold">{event.location}</span> on{" "}
                <span className="font-semibold">
                  {dayjs(event.event_date).format("MMMM D, YYYY h:mm A")}
                </span>
                . Don't miss out, kindly confirm your attendance before{" "}
                <span className="font-semibold">
                  {dayjs(event.rsvp_deadline).format("MMMM D, YYYY h:mm")}
                </span>
                .
              </p>
            </div>
            <hr className="m-4 border-t border-[#D9D9D929]" />

            {/* Location */}
            <div className="px-5 space-y-3 pb-6">
              {/* Organizer */}
              <div className="flex items-start space-x-2">
                <CrownSVG />
                <div className="flex space-x-1">
                  <span className="font-medium">{event.full_name}</span>
                  <span>(Organizer)</span>
                </div>
              </div>

              {/* Event Name - Event Type */}
              <div className="flex items-start space-x-2">
                <PopperSVG />
                <div className="flex space-x-1">
                  <span className="font-medium">{event.event_title}</span>
                  {/* <span>- {event.event_type}</span> */}
                </div>
              </div>

              {/* Date */}
              <div className="flex items-start space-x-2">
                <CalendarSVGEvent />
                <div className="flex space-x-1">
                  <span className="font-medium">
                    {dayjs(event.event_date).format("MMM D, YYYY")}
                  </span>
                  <span>({dayjs(event.event_date).format("h:mm A")})</span>
                </div>
              </div>

              <div className="flex items-start space-x-2">
                <div className="w-5 h-5 flex-shrink-0 mt-0.5">
                  <LocationSVG />
                </div>

                <div>
                  <p className="font-medium">Location</p>
                  <p>{event.location}</p>
                </div>
              </div>

              <div className="flex items-start space-x-2">
                <div className="w-5 h-5 flex-shrink-0 mt-0.5">
                  <NotesSVG />
                </div>

                <div>
                  <p className="font-medium">Description</p>
                  <p className="select-text" style={{ whiteSpace: "pre-line" }}>{event.event_desc}</p>
                </div>
              </div>

              {event?.has_dress_code === "1" && (
                <>
                  <div className="flex items-start space-x-2">
                    <DresscodeSVG />
                    <div>
                      <p className="font-medium">Clothes/Attire</p>
                      <p>{event.dress_code_desc}</p>
                    </div>
                  </div>

                  {/* Dress images */}
                  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 mt-3">
                    {event?.dress_img_1 && (
                      <img
                        src={event?.dress_img_1}
                        alt="dress 1"
                        className="w-full h-40 object-cover rounded-xl"
                      />
                    )}
                    {event?.dress_img_2 && (
                      <img
                        src={event?.dress_img_2}
                        alt="dress 2"
                        className="w-full h-40 object-cover rounded-xl"
                      />
                    )}
                    {event?.dress_img_3 && (
                      <img
                        src={event?.dress_img_3}
                        alt="dress 3"
                        className="w-full h-40 object-cover rounded-xl"
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* RSVP Buttons */}
      <div className="bg-gradient-to-t from-[#322759] via-[#32275985] to-transparent fixed bottom-0 z-[10] left-0 right-0 rounded-t-3xl py-4 shadow-lg">
        <div className="flex justify-center space-x-8 px-2 lg:px-8">
          {[
            {
              type: "1",
              label: "Going",
              color: "text-green-600",
              Icon: GoingSVG,
            },
            {
              type: "2",
              label: "Maybe",
              color: "text-yellow-500",
              Icon: MaybeSVG,
            },
            {
              type: "0",
              label: "Can’t Go",
              color: "text-red-500",
              Icon: CantGoSVG,
            },
          ].map(({ type: btnType, label, color, Icon }) => (
            <button
              key={btnType}
              onClick={() => {
                setType(btnType);
                setOpen(true);
              }}
              className="flex flex-col items-center"
            >
              <div className="border-2 w-24 h-24 lg:w-42 lg:h-42 flex flex-col items-center justify-center bg-white rounded-full shadow">
                <Icon />
                <span className={`mt-2  ${color}`}>{label}</span>
              </div>
            </button>
          ))}
        </div>
      </div>

      <RSVPModal
        id={eventCode}
        isOpen={open}
        onClose={() => {
          setOpen(false);
        }}
        type={type}
      />
    </div>
  );
};
